<template>
  <div class="ProjectItem">
    <a :href="item.detail_project_url" class="logo" v-if="!!item.network">
      <img src="http://placehold.it/60x60" class="resp-img" alt="logo">
    </a>

    <div 
      :href="item.detail_project_url" class="image"
      :style="imageStyle">
      <a :href="item.detail_project_url" class="link"></a>
    </div>

    <div class="budget-bar" v-if="item.funding_percentage <= 100">
      <span class="b" :style="`width:${item.funding_percentage}%`">
        {{item.funding_percentage }}%
      </span>
    </div>
    <div class="budget-bar" v-else>
      <span class="b" style="width:100%">100%</span>
    </div>
    <h4 class="title">
      <a :href="item.detail_project_url">
        {{item.title}}
      </a>
    </h4>
    <p class="data">
      <span class="row" v-if="!item.is_a_recurrent_donation">
        <b>
          &euro; {{item.funded_amount}}
        </b> 
        {{ $t('raccolti') }}
      </span>
      <span class="sep" v-if="!item.is_a_recurrent_donation"> | </span>
      <span class="row" v-if="!item.is_a_recurrent_donation">
        <b>
          {{item.num_contributors }}
        </b> 
        {{ $t('sostenitori') }}
      </span>
      <span class="row recurring_donation" v-if="!!item.is_a_recurrent_donation">
        <b>
          {{ $t('donazione ricorrente') }}
        </b>
      </span>
      <span class="sep" v-if="!!item.is_a_recurrent_donation"> | </span>
      <span class="row" v-if="!!item.is_a_recurrent_donation">
        <b>
          {{ item.contributed_subscriptions_count }}
        </b> 
        {{ $t('iscritti') }}
      </span>
      <span class="sep" v-if="!!item.is_a_recurrent_donation"> | </span><br/>
      <span class="row" v-if="!!item.is_a_recurrent_donation">
        <b>
          {{item.subscriptions_reached_amount_per_month}}
        </b> &euro; {{ $t('mensili') }}
      </span>
    </p>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "ProjectItem",
  props: {
    item: {
      type: Object,
      default: ()=>{ 
        return {
        } 
      }
    }
  },
  data: function(){
    return {
      placeholder: 'https://picsum.photos/1280/720'
    }
  },
  computed: {
    imageStyle(){
      let url,
        item = this.item;

      if(!!item.get_video_preview){
        url = item.get_video_preview
      }else if(!!item.image){
        url = item.image
      }else if(!!item.creator && !!item.creator.pic){
        url = item.creator.pic
      }else{
        url = this.placeholder
      }
      console.log(`${this.item.title}, ${url}`)
      return {
        backgroundImage: `url("${url}")`
      };
    }
  }
};
</script>
<style lang="less" scoped>
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";

  .ProjectItem{
    position: relative;
    padding-top: 15px;

    .link{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    .logo
    {
        position: absolute;
        right: 5px;
        top: 0;
        display: block;
        z-index: 2;
        /*border: 1px solid @white;*/
        .drop-shadow(0, 3px, 6px, .2);
        .box-sizing();
        background: @white;
        width: 54px;
        height: 54px;
    }

    .sep{
      display: none;
      @media (min-width: @bootstrap-md){
        display: inline-block;
      }
    }

    .row{
      display: block;
      @media (min-width: @bootstrap-md){
        display: inline-block;
      } 
    }

    .image
    {
        display: block;
        position: relative;
        z-index: 1;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
        width: 100%;
        background: no-repeat 50% 50%;
        background-size: cover;

        iframe, object, embed, img
        {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: auto;
        }
    }

    .title
    {
        font-weight: @Medium;
        padding: 14px 0 0;

        > a
        {
            color: @black;
        }
    }

    .data
    {
        font-size: 14px;
        padding: 10px 0 0;
        .ellipsis();
        .recurring_donation{
            color: @dataRecurringDonationColor;
            b, *{
                color: @dataRecurringDonationColor;
            }
        }
        b
        {
            color: @black;
            font-weight: @Medium;
        }
    }

    .std-carousel-four &
    {
        padding-top: 10px;

        .logo
        {
            width: 40px;
            height: 40px;
        }
    }

    @media @mq_ml
    {
        .logo
        {
            width: 40px;
            height: 40px;
        }
    }

    @media @mq_mp
    {
        padding-top: 10px;

        .title
        {
            font-size: 14px;
            padding: 16px 0 0;
        }

        .data
        {
            font-size: 11px;
            padding: 7px 0 0;
        }

        .mp12 > &
        {
            .title
            {
                font-size: 16px;
            }

            .data
            {
                font-size: 14px;
            }
        }
    }
  }
</style>
